import React from 'react';
import { HeroSection } from './HeroSection';
import { EmpatheticLead } from './EmpatheticLead';
import { ProductReveal } from './ProductReveal';
import { ClosingCTA } from './ClosingCTA';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden" data-id="element-162">
      <HeroSection data-id="element-163" />
      <EmpatheticLead data-id="element-164" />
      <ProductReveal data-id="element-165" />
      <ClosingCTA data-id="element-166" />
    </main>;
}